import { hueOf } from 'BomdisoftComponents/entity-mark/hue';

export type TagColours = { '--tag-fill-dark': string; '--tag-fill-light': string; '--tag-ink-dark': string; '--tag-ink-light': string };

export const tagColours = (id: string): TagColours => {
  const hue = hueOf(id);
  return {
    '--tag-fill-dark': `oklch(30% 0.06 ${hue})`,
    '--tag-fill-light': `oklch(94% 0.04 ${hue})`,
    '--tag-ink-dark': `oklch(88% 0.07 ${hue})`,
    '--tag-ink-light': `oklch(42% 0.105 ${hue})`,
  };
};

export const tagStyle = (id: string) =>
  Object.entries(tagColours(id))
    .map(([property, value]) => `${property}: ${value}`)
    .join('; ');
